module.exports = __webpack_public_path__ + "static/media/rule14_onLight_logo.d08b0c01.png";